

import React from 'react';
import './scss/park-mode-privacy-agreement-dialog.style.scss';
import './scss/quill.snow.css';
import { Button, Dialog, DialogContent } from '@material-ui/core';
import i18n from '../../i18n';
import ClearIcon from '@material-ui/icons/Clear';

export function ParkModePrivacyAgreementDialog(props: {
    onConfirm: () => void;
    handleClose: () => void;
    title: string;
    htmlContent: string;
}) {

    return (
        <Dialog
            open={true}
            onClose={() => {
                props.handleClose()
            }}
            className='parkModePrivacyAgreementDialog'
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
            fullScreen
        >
            <div className='close' onClick={() => {
                props.handleClose()
            }}>
                <ClearIcon className='clearIcon' />
            </div>
            <DialogContent >
                <div className='dialog-content'>
                    <div className='PrivacyApgreementText ql-editor'>
                        {/* <div className='subTitle'>
                            <span>{props.title}</span>
                        </div> */}
                        <div className='html-content' dangerouslySetInnerHTML={{ __html: props.htmlContent }}></div>
                    </div>
                    <div className='confirm-box'>
                        <Button className='confirm-btn' onClick={() => { props.onConfirm() }}>
                            {i18n.t('prk_mode_text_i_agree')}
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>

    )
}